import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { EventDTO } from 'src/app/api/models';
import { Floor } from 'src/app/api/models/showcases-dto';
import { AllocationService, LookupService } from 'src/app/api/services';
import { SharedService } from 'src/app/services/shared.service';

@Component({
  selector: 'app-create-showcase-form',
  templateUrl: './create-showcase-form.component.html',
  styleUrls: ['./create-showcase-form.component.scss']
})
export class CreateShowcaseFormComponent implements OnInit {

  @Output() closeSidenav: EventEmitter<any> = new EventEmitter();

  showcaseForm: FormGroup = new FormGroup({});
  showShowcase: boolean = false;
  loading: boolean = false;
  floors: Floor[] = [];
  event?: EventDTO;

  constructor(
    public translateService: TranslateService,
    public allocationService: AllocationService,
    public lookupService: LookupService,
    public sharedService: SharedService,
    private fb: FormBuilder
  ) { }

  ngOnInit(): void {
    this.event = this.sharedService.event;
    this.buildForm();
    this.loadFloors();
    setTimeout(() => this.showShowcase = true, 200)
  }

  //Costruzione del form
  buildForm() {
    this.showcaseForm = this.fb.group({
      description: new FormControl("", Validators.required),
      code: new FormControl("", Validators.required),
      area: new FormControl("", Validators.required),
      order: new FormControl("", Validators.required),
      floorCode: new FormControl("", Validators.required),
      securityDeviceId: new FormControl(""),
    });
  }

  //Caricamento di tutti i piandi dello showroom
  loadFloors() {
    if (this.event) {
      this.loading = true;
      this.lookupService.getFloors(this.event.id).subscribe(
        (res) => {
          this.setFloors(res);
          this.loading = false;
        },
        (err) => {
          console.log(err);
          this.sharedService.openSnackBar(this.translateService.instant('PAGES.ALLOCATION.CREATE_SHOWCASE_DIALOG.NOTIFICATION.FLOORS_ERROR'), true);
          this.loading = false;
          this.closeDialog();
        }
      )
    }
  }

  //Se ci sono dei piani allora li setto, altrimenti mostro un errore e chiudo la finestra di creazione
  setFloors(floors: Floor[]) {
    if (floors.length > 0) {
      this.floors = floors;
    } else {
      this.sharedService.openSnackBar(this.translateService.instant('PAGES.ALLOCATION.CREATE_SHOWCASE_DIALOG.NOTIFICATION.FLOORS_ERROR'), true);
      this.closeDialog();
    }
  }

  //Effettuo la creazione dello showcase
  createShowcase() {
    this.showcaseForm.markAllAsTouched();
    if (this.event && this.showcaseForm.valid) {
      this.loading = true;
      this.allocationService.createNewShowcase(this.event.id, this.showcaseForm.value).subscribe(
        (res) => {
          this.sharedService.openSnackBar(this.translateService.instant('PAGES.ALLOCATION.CREATE_SHOWCASE_DIALOG.NOTIFICATION.SUCCESS'), false);
          this.closeDialog(true);
          this.loading = false;
        },
        (err) => {
          console.log(err);
          this.sharedService.openSnackBar(this.translateService.instant('PAGES.ALLOCATION.CREATE_SHOWCASE_DIALOG.NOTIFICATION.ERROR'), true);
          this.loading = false;
        })
    }
  }

  closeDialog(isShowcaseCreated?: boolean): void {
    this.showShowcase = false;
    setTimeout(() => this.closeSidenav.emit(isShowcaseCreated), 200)
  }
}

